export default __webpack_public_path__ + "static/media/schoolDate1.69e537c5.png";